'use strict';

module.exports = function () {
    const $document = $(document);
    const $body = $('body');
    $document.on('openSlider', function (e, data) {
        let target = data.target;
        if (target) {
            const $targetEle = $(target);
            if ($targetEle.length) {
                $body.addClass('slider-open');
                if ($targetEle.hasClass('size-chart-overlay')) {
                    $body.addClass('size-chart-open');
                }
                $targetEle.addClass('active');
                setTimeout(function () {
                    $targetEle.addClass('slider-animate');
                }, 0);
            }
        }
        setTimeout(function () {
            if (!$('.trolley-cards-container').hasClass('slick-initialized')) {
                $('.trolley-cards-container').slick({
                    slidesToShow: 2.5,
                    slidesToScroll: 1,
                    arrows: true,
                    dots: true,
                    infinite: false,
                    responsive: [
                        {
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 4.23,
                            },
                        },
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 2.15,
                            },
                        },
                    ],
                });
            }
            if (!app.checkBreakPoint('md')) {
                if (!$('.pen-stroke-guide').hasClass('slick-initialized')) {
                    $('.pen-stroke-guide .card-wrapper').slick({
                        slidesToShow: 2.25,
                        slidesToScroll: 1,
                        arrows: true,
                        dots: true,
                        infinite: false,
                    });
                }
            }
            if ($('.size-chart-overlay table').hasClass('kids-size-chart')) {
                $('.pdp-right-wrapper .slider-container').addClass('kids-size-chart-overlay');
            }
        }, 300);
    });
    $document.on('click', '.slider-opener', function (e) {
        e.preventDefault();
        $document.trigger('openSlider', {
            target: $(this).data('target-slider'),
        });
    });
    $document.on('click', '.slider-close', function () {
        let $container = $(this).closest('.slider-container');
        const $childcintainer = $container.find('.slider-container.active');
        $container = $childcintainer.length ? $childcintainer : $(this).closest('.slider-container');
        const hasMoreActiveSlider = $body.find('.slider-container.active').length > 1;
        $('.size-chart .size-chart-collapsible').empty();
        $('.size-chart-overlay').removeClass('kids-size-chart-overlay');
        $body.removeClass('size-chart-open');

        if ($container.hasClass('right-to-left')) {
            $container.removeClass('slider-animate');
            setTimeout(function () {
                if (!hasMoreActiveSlider) {
                    $body.removeClass('slider-open');
                }
                $container.removeClass('active');
            }, 300);
        } else {
            $container.removeClass('active slider-animate');
            $body.removeClass('slider-open');
        }
    });
    $('body').toggleClass('no-scroll-space', window.outerWidth === document.body.scrollWidth);
};
